import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { Box } from '@lifeomic/chroma-react/components/Box';
import {
  Alert,
  AlertIcon,
  AlertBody,
} from '@lifeomic/chroma-react/components/Alert';
import { Info } from '@lifeomic/chromicons';
import { Text } from '@lifeomic/chroma-react/components/Text';

const messages = defineMessages({
  message: {
    id: 'NoSurveysAlert.message',
    defaultMessage: 'Subject has no survey responses',
  },
});

export const useStyles = makeStyles((_theme: Theme) => ({
  root: {},
}));

export type NoSurveysAlertOwnProps = {};

export type NoSurveysAlertProps = NoSurveysAlertOwnProps;

const NoSurveysAlert: React.FC<NoSurveysAlertProps> = () => {
  const { formatMessage } = useIntl();

  return (
    <Box fullHeight fullWidth justify="center" align="center">
      <Alert>
        <AlertIcon icon={Info} />
        <AlertBody>
          <Text size="subbody">{formatMessage(messages.message)}</Text>
        </AlertBody>
      </Alert>
    </Box>
  );
};

export default React.memo(NoSurveysAlert);
